<h4 mat-dialog-title>Crop Image</h4>
<mat-dialog-content>

    <div class="row g-4">
        <div class="col-6">
            <div class="card card-image preview">
                <img *ngIf="croppedImage != ''" [src]="croppedImage"
                alt="Preview" />
            </div>
        </div>
        <div class="col-6">
            <div class="card card-image">

                <image-cropper [imageFile]="data?.imageFile" [imageURL]="data?.imageUrl"
                [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="aspectRatio" [aspectRatio]="1/1"
                format="jpeg" [roundCropper]="isRoundedAspect" (imageCropped)="imageCropped($event)"
                [(transform)]="transform" [backgroundColor]="colorPicked" (transformChange)="imageTransformed($event)"
                [containWithinAspectRatio]="true"></image-cropper>
            </div>
        </div>
        <div class="col-6">
            <div class="theming-color-items">
                <div class="color-item">
                    <div class="content">
                        <div class="label">Background Color</div>
                        <div class="value">{{colorPicked}}</div>
                    </div>
                    <div [style.background-color]="colorPicked" mat-ripple class="color-thumb">
                        <input type="color" [(ngModel)]="colorPicked" />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6">
            <mat-label id="radio-group-label">Crop</mat-label>
            <mat-radio-group class="d-flex align-items-start" aria-labelledby="radio-group-label"
                aria-label="Select an option" [(ngModel)]="aspectRatio">
                <mat-radio-button [value]="true">Proportional</mat-radio-button>
                <mat-radio-button class="ms-0" [value]="false">Free</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>

</mat-dialog-content>
<mat-dialog-actions class="dailog-footer-buttons">
    <button mat-raised-button type="button" (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="handleOkClick()">Ok</button>
</mat-dialog-actions>